module.exports = __webpack_public_path__ + "static/img/scpi.275febf.png";


//////////////////
// WEBPACK FOOTER
// ./node_modules/CGdesign/src/assets/icons/scpi.png
// module id = N4J3
// module chunks = 1